import { FC, useMemo, useCallback, useEffect } from 'react'

import { List, Pagination, EmptyList, SafetyCaseHazardMitigationCard } from '../../../components'
import { ISafetyCaseHazardMitigation, IActionOption } from '../../../interfaces'

type SafetyCaseHazardMitigationsCardsListProps = {
  pagination: { pageSize: number; pageIndex: number }
  setPagination: (values: { [key: string]: number }) => void
  mitigations: ISafetyCaseHazardMitigation[] | undefined
  actionsButtonOptions?: IActionOption<ISafetyCaseHazardMitigation>[]
  isLoading: boolean
}

const SafetyCaseHazardMitigationsCardsList: FC<SafetyCaseHazardMitigationsCardsListProps> = props => {
  const { mitigations, pagination, setPagination, actionsButtonOptions, isLoading } = props

  const totalItemsCount = mitigations?.length || 0

  const { pageIndex, pageSize } = pagination

  const setPageSize = useCallback((pageSize: number) => setPagination({ pageSize }), [setPagination])

  const setPageIndex = useCallback((pageIndex: number) => setPagination({ pageIndex }), [setPagination])

  const totalPageCount = useMemo(() => Math.ceil(totalItemsCount / pageSize), [totalItemsCount, pageSize])

  const mitigationsPage = useMemo(
    () => (mitigations || []).slice(pageIndex * pageSize, pageIndex * pageSize + pageSize),
    [mitigations, pageIndex, pageSize],
  )

  useEffect(() => {
    if (pageIndex > totalPageCount) {
      setPageIndex(totalPageCount)
    }
  }, [pageIndex, setPageIndex, totalPageCount])

  const canNextPage = pageIndex < totalPageCount

  const canPreviousPage = pageIndex > 0

  return (
    <>
      <div className="overflow-auto h-100">
        <List
          data={mitigationsPage}
          ListItem={SafetyCaseHazardMitigationCard}
          noDataContent={<EmptyList>No Mitigations found.</EmptyList>}
          actionsButtonOptions={actionsButtonOptions}
          isLoading={isLoading}
        />
      </div>

      <Pagination
        pageIndex={pageIndex}
        setPageIndex={setPageIndex}
        pageSize={pageSize}
        setPageSize={setPageSize}
        totalItemsCount={totalItemsCount}
        totalPageCount={totalPageCount}
        canNextPage={canNextPage}
        canPreviousPage={canPreviousPage}
      />
    </>
  )
}

export default SafetyCaseHazardMitigationsCardsList
